import { FLIGHTS_COUNTER, FLIGHT_SECONDS_COUNTER } from './constants';
import type { GetEffectiveUsage, IntervalUnit, UsageCounters } from './types';

const SECONDS_PER_HOUR = 3600;

const getFlightSecondsAsHours = (counters: UsageCounters): number | null => {
    const flightSeconds = counters[FLIGHT_SECONDS_COUNTER];

    return flightSeconds === undefined ? null : flightSeconds / SECONDS_PER_HOUR;
};

const usageByIntervalUnit: Record<IntervalUnit, (counters: UsageCounters) => number | null> = {
    CYCLES: () => null,
    FLIGHTS: counters => counters[FLIGHTS_COUNTER] ?? null,
    HOURS: getFlightSecondsAsHours
};

const getEffectiveUsage: GetEffectiveUsage = ({ counters, intervalUnit }) =>
    usageByIntervalUnit[intervalUnit]?.(counters ?? {}) ?? null;

export default getEffectiveUsage;
